
import React, {Component, Fragment} from 'react'
import CategoryItemWithImage from './CategoryItemWithImage'
import CategoryItemWithoutImage from './CategoryItemWithoutImage'
import ModifierDialogue from '../modifier/ModifierDialogue'

var modifierDialogueUtil = require('../modifier/modifierDialogueUtil');
var displaySettingsUtils = require('../../../../utils/domain/settings/displaySettingsUtils');
var saleContextUtil = require('../../utils/saleContextUtil');

class CategoryItem extends Component 
{
    constructor(props)
    {
        super(props);
        this.onClick = this.onClick.bind(this);
        this.renderModifierDialogue = this.renderModifierDialogue.bind(this);

        this.state = {};
    }

    render()
    {
        let component = null;
        if (displaySettingsUtils.getMenuItemLayout() == "LayoutWithImages")
            component = <CategoryItemWithImage item={this.props.item} category={this.props.category} 
                                          enabled={this.props.enabled} isSnoozed={this.props.isSnoozed}
                                          onClick={this.onClick}/>

        else 
            component = <CategoryItemWithoutImage item={this.props.item} category={this.props.category} 
                                         enabled={this.props.enabled} isSnoozed={this.props.isSnoozed}
                                         onClick={this.onClick}/>

        return <Fragment>
                    {component}
                    {this.renderModifierDialogue()}
                </Fragment>
    }

    onClick()
    {
        if (!this.props.enabled || this.props.snoozed)
            return;

        let menuItem = this.props.item;
        let saleContext = this.props.saleContext;
        let sale = saleContext.sale;

        var autoSelectedModifierItems = modifierDialogueUtil.buildAutoSelectedModifierItems(menuItem);
        var requiredModifiers = modifierDialogueUtil.buildRequiredModifiers(menuItem, true);

        var menuContext = modifierDialogueUtil.buildNewMenuContext(null, menuItem);
        var saleItem = modifierDialogueUtil.buildSaleItemFromMenuContext(sale, menuContext, 1, autoSelectedModifierItems);

        if (requiredModifiers.length <= 0)
        {
            sale.saleItems.push(saleItem);
            saleContextUtil.raiseSaleContextSaleChangeEvent(true);
        }
        else
        {
            this.state.modifierDialogueContext = {};
            this.state.modifierDialogueContext.saleItem = saleItem;
            this.setState({});
        }
    }

    renderModifierDialogue()
    {
        if (this.state.modifierDialogueContext == null)
            return null;

        var modifiersViewModels = modifierDialogueUtil.buildModifiersViewModels(this.state.modifierDialogueContext.saleItem);
        if (modifiersViewModels.length <= 0)
        {
            this.state.modifierDialogueContext = null;
            return;
        }

        return <ModifierDialogue 
                    saleItem = {this.state.modifierDialogueContext.saleItem}
                    startingModifierIndex = {0}
                    modifiersViewModels={modifiersViewModels}
                    isNewOrderFlow={true}
                    sale={this.props.saleContext.sale}
                    menu={this.props.saleContext.primaryMenu}
                    onCancel={()=>
                    {
                        this.state.modifierDialogueContext = null;
                        this.setState({});
                    }}
                    onSave = {(modifiersViewModels)=>
                    {
                        var saleItem = this.state.modifierDialogueContext.saleItem;
                        
                        this.state.modifierDialogueContext = null;
                        this.setState({});

                        modifierDialogueUtil.updateSaleItemWithModifiersViewModels(this.props.saleContext.sale, saleItem, modifiersViewModels);
                        this.props.saleContext.sale.saleItems.push(saleItem);
                        saleContextUtil.raiseSaleContextSaleChangeEvent(true);
                    }}
                />
    }
}

export default CategoryItem